<template>
  <a-modal
    :title='this.$store.getters.language["depart"]'
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="this.$store.getters.language['common.closeButton']">
    <a-row :gutter="10">
      <a-col :md="10" :sm="24">
        <a-tree
          checkable
          :class="treeScreenClass"
          @check="onCheck"
          :checkStrictly="checkStrictly"
          :checkedKeys="checkedKeys"
          v-if="departTree&&departTree.length"
          :expandedKeys="iExpandedKeys"
          @expand="onExpand"
          :autoExpandParent="autoExpandParent"
          :treeData="departTree"
        />
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
  import {queryDepartTreeList, searchByKeywords, deleteByDepartId} from '@/api/api'
  import {httpAction, deleteAction, getAction,postAction} from '@/api/manage'
  export default {
    name: "JSelectDepartModalBySingleapplication",
    props:{
      multi:{
        type:Boolean,
        default:true
      }
    },
    data() {
      return {
        departTree: [],
        loading: false,
        visible: false,
        disableSubmit: false,
        confirmLoading:false,
        title:"部门",
        autoExpandParent: true,
        checkedKeys:[],
        iExpandedKeys:[],
        checkedRows:[],
        checkStrictly:true,
      }
    },
    computed:{
      treeScreenClass() {
        return {
          'my-dept-select-tree': true,
          'fullscreen': this.fullscreen,
        }
      },
    },
    methods:{
      /*handleOk(){
        this.$emit('ok');
        this.close()
      },*/
      onCheck(checkedKeys,info){
        if(!this.multi){
          let arr = checkedKeys.checked.filter(item => this.checkedKeys.indexOf(item) < 0)
          this.checkedKeys = [...arr]
          // this.checkedRows = (this.checkedKeys.length === 0) ? [] : [info.node.dataRef]
        }else{
          if(this.checkStrictly){
            this.checkedKeys = checkedKeys.checked
          }else{
            this.checkedKeys = checkedKeys
          }
          // this.checkedRows = this.getCheckedRows(this.checkedKeys)
        }
      },

      handleOk(){
        let checkRow = this.getCheckedRows(this.checkedKeys)
        this.$emit('ok',checkRow);
        this.close()
        /* getAction("/sys/sysDepart/addStandardDepart",{'applicationCode':this.$store.getters.applicationCode}).then((res) => {
           if (res.success) {
             this.$emit('ok');
             this.close()
             // this.artificialPersonList = res.result;
           }
         })*/
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      loadTree(applicationCode,checkIdstr) {
        this.checkedKeys = [];
        if(checkIdstr){
          this.checkedKeys = checkIdstr.split(',')
          this.iExpandedKeys = checkIdstr.split(',')
        }
        this.visible = true;
        var that = this
        that.departTree = []
        queryDepartTreeList({"applicationCode":applicationCode}).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.departTree.push(temp)
              // that.setThisExpandedKeys(temp)
              // that.getAllKeys(temp);
              // console.log(temp.id)
            }
            if(!checkIdstr){
              this.iExpandedKeys.push(that.departTree[0].key)
            }
            this.loading = false
          }
        })
      },
      // 根据 checkedKeys 获取 rows
      getCheckedRows(checkedKeys) {
        const forChildren = (list, key) => {
          for (let item of list) {
            if (item.id === key) {
              return item
            }
            if (item.children instanceof Array) {
              let value = forChildren(item.children, key)
              if (value != null) {
                return value
              }
            }
          }
          return null
        }
        let rows = []
        for (let key of checkedKeys) {
          let row = forChildren(this.departTree, key)
          if (row != null) {
            rows.push(row)
          }
        }
        return rows
      },

      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys)
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },

    }
  }
</script>

<style lang="less" scoped>
  // 限制部门选择树高度，避免部门太多时点击确定不便


</style>